"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDesignAllowedForPrintableIdx;
const constants_1 = require("./constants");
const newrelic_1 = require("../split.io/newrelic");
function isDesignAllowedForPrintableIdx(design, printableIdx) {
  var _a;
  const currentPageNumber = printableIdx + 2; // Allowed pages start at 2, the cover counts as 0, 1
  if (design.allowedPages === constants_1.ALL) {
    return true;
  } else if (design.allowedPages === constants_1.NONE || design.allowedPages === constants_1.FIRST) {
    return false;
  }
  // design.allowedPages: "15...15", "2...last", etc...
  const rangeArr = ((_a = design.allowedPages) === null || _a === void 0 ? void 0 : _a.split('...').map(x => {
    const num = parseFloat(x);
    if (isNaN(num)) {
      // This means we're dealing with a string like 'last'
      return x;
    }
    return num;
  })) || [];
  if (!rangeArr.length) {
    if ((0, newrelic_1.canNR)()) {
      window.newrelic.addPageAction(`isDesignAllowedForPrintableIdx: Invalid allowedPages (${design.allowedPages}) in design ${design.designId}`);
    }
    return false;
  }
  // This means the design is for one specific page and we have only one value
  if (rangeArr.length === 1) {
    return currentPageNumber === rangeArr[0];
  } else if (rangeArr[1] === constants_1.LAST) {
    // This means we have something like 2...last, so we can make sure the page index is greater than or equal to the first number
    return typeof rangeArr[0] === 'number' ? currentPageNumber >= rangeArr[0] : false;
  } else {
    // This means we're dealing with a range between two numbers
    return (typeof rangeArr[0] === 'number' ? currentPageNumber >= rangeArr[0] : false) && (typeof rangeArr[1] === 'number' ? currentPageNumber <= rangeArr[1] : false);
  }
}